<script setup lang="ts">
import type { Component, Page } from '@bloomreach/spa-sdk'

/**
 * SDX
 */

const props = defineProps<{
    component: Component
    page: Page
}>()

const { component } = toRefs(props)
const data = computed(() => component.value.getModels())

/**
 * Component
 */
const itemsTab = computed(
    () =>
        data.value.blogSwitcher?.map((el: { name: string; url: string }) => ({
            name: el.name,
            url: el.url,
        })) || [],
)
const activeButton = ref('')
const route = useRoute()

onMounted(() => {
    setBtn()
})

function normalizePath(path: string): string {
    return new URL(path, window.location.origin).pathname.replace(/\/$/, '')
}

function findMatchingTab(path: string) {
    const normalizedPath = normalizePath(path)
    return itemsTab.value.find((tab: { url: string }) => {
        return normalizedPath === normalizePath(tab.url)
    })
}

function setBtn() {
    const path = route.path.replace(/\/$/, '')
    const matchingTab = findMatchingTab(path)
    activeButton.value = matchingTab?.name ?? itemsTab.value[0]?.name ?? null
}
</script>

<template>
    <section class="mb-8 px-3 md:px-0">
        <div class="mb-6 mt-16 flex justify-center md:mb-8 lg:mb-11">
            <h1 class="text-2md font-bold md:text-5xl">{{ data.blogTitle }}</h1>
        </div>

        <div
            v-if="itemsTab.length > 1"
            class="relative mx-auto mt-4 flex h-[50px] w-full justify-between gap-1 overflow-hidden rounded-[100px] border-2 border-plus-primary bg-white md:w-[464px] lg:w-[400px]"
        >
            <a
                v-for="(tab, idx) in itemsTab"
                :key="idx"
                :href="tab.url"
                class="relative flex h-full w-1/2 items-center justify-center rounded-[100px] text-center text-plus-primary transition-colors duration-300 ease-in-out"
                :class="{ '!bg-plus-primary text-plus-secondary': activeButton === tab.name }"
            >
                {{ tab.name }}
            </a>
        </div>
    </section>
</template>

<style scoped lang="scss">
div:focus-within {
    overflow: initial;
}
a {
    &:hover {
        @apply bg-plus-blue-500;
    }
    &:focus-visible {
        outline: none;
        &::after {
            content: '';
            outline: none;
            width: calc(100% + 4px);
            height: calc(100% + 4px);
            position: absolute;
            top: -2px;
            left: -2px;
            border: 2px solid #fe19ff;
            border-radius: 100px;
        }
    }
    &:active {
        @apply bg-plus-blue-100;
    }
}
</style>
